module.exports = __webpack_public_path__ + "static/media/Jenny-Beach-Series.fe998faa.png";